import { Screen } from './Screen';
import { parseRegie, parseRoster } from './regie';

/**
 * The converter instance from / to player instance
 */
export const ScreenConverter = {
    fromFirestore: (data: any): Screen =>
        Object.assign(new Screen(), {
            _id: data.id,
            _name: data.name,
            _status: data.status,
            _gameID: data.gameID,
            _instanceID: data.instanceID,
            _currentSessionID: data.currentSessionID,
            _description: data?.description,
            _playerCount: data?.playerCount ?? 0,
            // Firestore Timestamp → epoch millis (additive; legacy docs lack it).
            _lastSeen: data?.lastSeen?.toMillis?.() ?? undefined,
            _animatorSeen: data?.animatorSeen?.toMillis?.() ?? undefined,
            // Battements de la page TV venant d'un téléphone / d'une vraie TV.
            _phoneSeen: data?.phoneSeen?.toMillis?.() ?? undefined,
            _tvSeen: data?.tvSeen?.toMillis?.() ?? undefined,
            _hiddenAt: data?.hiddenAt?.toMillis?.() ?? undefined,
            _showQR: data?.showQR ?? false,
            _paused: data?.paused ?? false,
            _muted: data?.muted ?? false,
            _idle: data?.idle ?? false,
            // Plain epoch-ms nonce (client time, not a server Timestamp) so the
            // optimistic snapshot never flickers to null between writes.
            _launchRequest: data?.launchRequest ?? undefined,
            _gameChangedAt: typeof data?.gameChangedAt === 'number' ? data.gameChangedAt : undefined,
            // Opaque per-game params blob (Phase 2B) — relayed verbatim to the game.
            _gameParams: data?.gameParams ?? undefined,
            // Réglages mémorisés par jeu (TV + télécommande).
            _gameParamsByGame: data?.gameParamsByGame ?? undefined,
            // One-shot stop nonce (Phase 2D) — plain epoch-ms, like launchRequest.
            _stopRequest: data?.stopRequest ?? undefined,
            // Generic in-game command {name, nonce} (e.g. Unquiz « show-next »).
            _gameCommand: data?.gameCommand ?? undefined,
            // Per-screen attract-screen languages. Additive: absent on every legacy
            // screen → undefined → the idle screen keeps its FR/EN default.
            // Hand-typed in the Firebase console (no UI writes it), so the shape is
            // NOT trusted: a string ("zh,en" — the natural mistake), a number or a
            // map would otherwise reach `.join`/`.filter` and throw during render,
            // which the top-level ErrorBoundary turns into a blank error page on an
            // unattended airport TV. Anything that isn't an array of strings
            // collapses to undefined → FR/EN default.
            _idleLanguages: Array.isArray(data?.idleLanguages)
                ? data.idleLanguages.filter((l: unknown) => typeof l === 'string')
                : undefined,
            // Double écran : formes vérifiées (champ écrit par la régie, lu sur la TV).
            _regie: parseRegie(data?.regie),
            _roster: parseRoster(data?.roster),
        }),
};
